


































































import {
  Vue, Component, Prop
} from "@/shared/vuepack";

@Component({})
export default class HsabExpenseCardColumns extends Vue {

  @Prop()
  isSubmittedExpense: boolean;
}
